import { useEffect, useState } from "react";
import ToolBar from "../../../components/ToolBar";
import CreateButton from "../../../components/ToolBar/Buttons/CreateButton";
import ContentBox from "../../../components/ContentBox/ContentBox";
import Listing from "./components/Listing/Listing";
import { details,  setDetails, deleteRecord, fetchList } from "./utils/slice";
import DeleteModal from "../../../components/Modals/DeleteModal";
import AddComponent from "./components/Form/AddComponent";
import EditComponent from "./components/Form/EditComponent";
import { AcronymsBreadcrumb } from "../../../config/BreadcrumbConfig";
import { toUpperCaseWithUnderscore } from "../../../utils/commonFunctions";
import { useAppDispatch } from "../../../utils/hooks/hooks";
import { CONSTANT } from "../../../config/Constant";
import { setEditLoading } from "../../../store/CommonSlice";
import ImportComponent from "./components/Form/ImportComponent";
import React from "react";

const moduleInfo = {
  title: "Acronym",
  permissionKeyPrefix: toUpperCaseWithUnderscore("Acronyms"),
};

/**
 * Renders the Acronyms component which displays a list of Acronyms, allows creation and editing of Acronyms,
 * and deletion of Acronyms. It also allows the user to set the number of Acronyms to display per page.
 *
 * @return {JSX.Element} The rendered Acronyms component.
 */
const Acronyms: React.FC<any> = () => {
  const dispatch = useAppDispatch();

  const [isCreateVisible, setIsCreateVisible] = useState(false);
  const [editDrawer, setEditDrawer] = useState(false);
  const [deleteValue, setDeleteValue] = useState<any>();

  const [isBookingVisible, setIsBookingVisible] = useState(false);

  useEffect(() => {
    dispatch(fetchList()).catch((error: any) => error);
  }, []);


  /**
  *  set loading on action button click and dispatch details 
  * api call and set loading to false on success and open drawer.
  * and throw error on failure.
   */
  const getDetails = (data: any, type: string) => {
    if (type === CONSTANT.DRAWER_TYPE.EDIT) {
      dispatch(setEditLoading([true, data.id]));
    }

    dispatch(details(data.id))
      .then((data: any) => {
        if (type === CONSTANT.DRAWER_TYPE.EDIT) {
          setEditDrawer(true);
          dispatch(setEditLoading([false, data.id]));
        }
      })
      .catch((error: any) => error);
  };


  return (
    <>
      <ToolBar breadcrumbs={AcronymsBreadcrumb}>
        <CreateButton
          name="Import"
          action={() => setIsBookingVisible(true)}
          permissionKey={`${moduleInfo.permissionKeyPrefix}_CREATE`}
        />
        <CreateButton
          action={() => setIsCreateVisible(true)}
          permissionKey={`${moduleInfo.permissionKeyPrefix}_CREATE`}
        />
      </ToolBar>
      <ContentBox>
        <Listing
          moduleInfo={moduleInfo}
          handleEditClick={(data: any) => {
            getDetails(data, CONSTANT.DRAWER_TYPE.EDIT);
          }}
          handleDeleteClick={setDeleteValue}
          handleViewClick={(data: any) => {
            getDetails(data, CONSTANT.DRAWER_TYPE.VIEW);
          }}
        />
        <AddComponent
          titleName={moduleInfo.title}
          open={isCreateVisible}
          close={() => setIsCreateVisible(false)}
        />

        <EditComponent
          titleName={moduleInfo.title}
          open={editDrawer}
          close={() => dispatch(setDetails(null)) && setEditDrawer(false)}
        />
        <ImportComponent
          titleName={moduleInfo.title}
          open={isBookingVisible}
          close={() => setIsBookingVisible(false)}
        />
        <DeleteModal
          title={moduleInfo.title}
          deleteValues={deleteValue}
          callApi={deleteRecord}
          close={() => setDeleteValue(null)}
        />
      </ContentBox>
    </>
  );
};

export default Acronyms;
